/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetEventLogQueryVariables = Types.Exact<{
  pageSize: Types.Scalars['Int'];
  pageNumber: Types.Scalars['Int'];
  sortDirection: Types.Scalars['String'];
  freeTextFilter: Types.Scalars['String'];
  startDate: Types.Maybe<Types.Scalars['Date']>;
  endDate: Types.Maybe<Types.Scalars['Date']>;
}>;


export type GetEventLogQuery = (
  { __typename?: 'Query' }
  & { eventLogs: (
    { __typename?: 'GetEventLogsResult' }
    & Pick<Types.GetEventLogsResult, 'isAvailableMoreData'>
    & { data: Array<(
      { __typename?: 'EventLogItem' }
      & Pick<Types.EventLogItem, 'id' | 'eventTypeName' | 'description' | 'eventTypeId' | 'userId' | 'userFullName' | 'ipAddress' | 'operationStatus' | 'timestamp'>
    )> }
  ) }
);


export const GetEventLogDocument = gql`
    query GetEventLog($pageSize: Int!, $pageNumber: Int!, $sortDirection: String!, $freeTextFilter: String!, $startDate: Date, $endDate: Date) {
  eventLogs(
    pageSize: $pageSize
    pageNumber: $pageNumber
    sortDirection: $sortDirection
    freeTextFilter: $freeTextFilter
    startDate: $startDate
    endDate: $endDate
  ) {
    data {
      id
      eventTypeName
      description
      eventTypeId
      userId
      userFullName
      ipAddress
      operationStatus
      timestamp
    }
    isAvailableMoreData
  }
}
    `;

/**
 * __useGetEventLogQuery__
 *
 * To run a query within a React component, call `useGetEventLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventLogQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      pageNumber: // value for 'pageNumber'
 *      sortDirection: // value for 'sortDirection'
 *      freeTextFilter: // value for 'freeTextFilter'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetEventLogQuery(baseOptions: Apollo.QueryHookOptions<GetEventLogQuery, GetEventLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventLogQuery, GetEventLogQueryVariables>(GetEventLogDocument, options);
      }
export function useGetEventLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventLogQuery, GetEventLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventLogQuery, GetEventLogQueryVariables>(GetEventLogDocument, options);
        }
export type GetEventLogQueryHookResult = ReturnType<typeof useGetEventLogQuery>;
export type GetEventLogLazyQueryHookResult = ReturnType<typeof useGetEventLogLazyQuery>;
export type GetEventLogQueryResult = Apollo.QueryResult<GetEventLogQuery, GetEventLogQueryVariables>;